<template>

</template>

<script>

   const serverURL ='https://www.starmaker-china.com/pds/';
 // const serverURL ='http://www.starmaker-china.com:8000/';
  // const serverURL ='http://127.0.0.1:8000/';

  const token ='';
  const userId ='';

    export default {
        // name: "Global",
      serverURL,
      token,
      userId
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Global.vue